import { isEmbeddedIframe } from '@/embed-base'

const MINI_TAB_PATH = {
  Home: '/pages/home/index',
  home: '/pages/home/index',
  HomeListArtist: '/pages/stars/index',
  HomeListAmbassador: '/pages/endorsement/index',
  CommunityIndex: '/pages/community/index',
  HomeCommunityIndex: '/pages/community/index',
  PersonalCenter: '/pages/user/index',
}

const MINI_TAB_NAME_BY_PATH = {
  '/': 'Home',
  '/home': 'Home',
  '/home/list/artist': 'HomeListArtist',
  '/home/list/ambassador': 'HomeListAmbassador',
  '/community': 'CommunityIndex',
  '/personal/center': 'PersonalCenter',
}

export function isMiniProgramSync() {
  // uni-app H5 的 web-view 是 iframe，不是小程序原生 web-view
  if (isEmbeddedIframe()) return false
  if (typeof window !== 'undefined' && window.__MP_IN_MINI__) return true
  try {
    if (sessionStorage.getItem('isMiniprogramEnter') === 'true') return true
  } catch (e) {
    // ignore
  }
  const ua = String(navigator.userAgent || '').toLowerCase()
  return ua.includes('miniprogram')
}

export function inferMiniTabName(routeName, path) {
  if (routeName && MINI_TAB_PATH[routeName]) return routeName
  const p = String(path || '').split('?')[0]
  return MINI_TAB_NAME_BY_PATH[p] || ''
}

export function buildMiniTabUrl(routeName, query = {}, path = '') {
  const name = inferMiniTabName(routeName, path)
  if (!name) return ''

  if (name === 'CommunityIndex' || name === 'HomeCommunityIndex') {
    const qs = []
    if (query.typeid) qs.push(`typeid=${encodeURIComponent(query.typeid)}`)
    if (query.celebritiesid) qs.push(`celebritiesid=${encodeURIComponent(query.celebritiesid)}`)
    if (query.search) qs.push(`search=${encodeURIComponent(query.search)}`)
    const base = MINI_TAB_PATH.CommunityIndex
    return qs.length ? `${base}?${qs.join('&')}` : base
  }

  return MINI_TAB_PATH[name] || ''
}

export function isMiniNativeTabRoute(routeName, path) {
  return !!inferMiniTabName(routeName, path)
}

function postSwitchTabToParent(url, query = {}) {
  try {
    window.parent.postMessage(
      {
        type: 'SWITCH_TAB',
        payload: { url, query },
      },
      '*'
    )
    return true
  } catch (e) {
    return false
  }
}

function reLaunchWxMiniTab(url) {
  if (typeof wx === 'undefined' || !wx.miniProgram || typeof wx.miniProgram.reLaunch !== 'function') {
    return false
  }
  wx.miniProgram.reLaunch({
    url,
    fail: () => {
      wx.miniProgram.switchTab({
        url: url.split('?')[0],
      })
    },
  })
  return true
}

export function reLaunchMiniTab(routeName, query = {}, path = '') {
  const url = buildMiniTabUrl(routeName, query, path)
  if (!url) return false

  if (isEmbeddedIframe()) {
    return postSwitchTabToParent(url, query)
  }

  return reLaunchWxMiniTab(url)
}

export function reLaunchMiniHome() {
  return reLaunchMiniTab('Home')
}

export function shouldUseNativeTabNav() {
  return isMiniProgramSync() || isEmbeddedIframe()
}
